import Vue from 'vue'
import PrivacyModal from "./modals/PrivacyModal.vue";
import TermsModal from "./modals/TermsModal.vue";
import PolicyModal from "./modals/PolicyModal.vue";
import TermsOfServicesText from "./terms-of-services.vue";
import PrivacyPolicyText from "./privacy-policy.vue";
import SubscriptionTerms from "./subscription-terms.vue";
import CookiePolicy from "./cookie-policy.vue";

Vue.component('privacy-modal', PrivacyModal)
Vue.component('terms-modal', TermsModal)
Vue.component('policy-modal', PolicyModal)
Vue.component('terms-of-services-text', TermsOfServicesText)
Vue.component('privacy-policy-text', PrivacyPolicyText)
Vue.component('subscription-terms-text', SubscriptionTerms)
Vue.component('cookie-policy-text', CookiePolicy)
